import { ContenteditableValueAccessorModule } from '@tinkoff/angular-contenteditable-accessor';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { EditProfileComponent } from './user/edit-profile/edit-profile.component';
import { SignalViewerCompComponent } from './components/signal-viewer-comp/signal-viewer-comp.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { LanguageChangeComponent } from './components/language-change/language-change.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import {
    MAT_MOMENT_DATE_FORMATS,
    MomentDateAdapter,
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { CustomPaginationLocalization } from './utils/custom-pagination-localization/custom-pagination-localization';
import { AddEmergencyContactDialogComponent } from './dialogs/add-emergency-contact-dialog/add-emergency-contact-dialog.component';
import { DeleteEmergencyContactDialogComponent } from './dialogs/delete-emergency-contact-dialog/delete-emergency-contact-dialog.component';

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        EditProfileComponent,
        SignalViewerCompComponent,
        LanguageChangeComponent,
        SideNavComponent,
        AddEmergencyContactDialogComponent,
        DeleteEmergencyContactDialogComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MatMenuModule,
        MatTooltipModule,
        MatIconModule,
        MatDialogModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatTabsModule,

        ContenteditableValueAccessorModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            isolate: false
        }),
    ],
    exports: [
        EditProfileComponent,
        SignalViewerCompComponent,
        LanguageChangeComponent,
        TranslateModule,
        MatTooltipModule,
        MatIconModule,
        MatDialogModule,
        MatPaginatorModule,
        SideNavComponent,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatTabsModule,
        FormsModule
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        { provide: MatPaginatorIntl, useClass: CustomPaginationLocalization }
    ]
})
export class ShareModule { }